import React from 'react';
import { Link } from '@framework/router/Next/Link';

const DealLink = ({ path, row, cellData }) => {
  const { cusip } = row;

  return (cellData ? (
    <Link
      to={ `${ path }?q=${ cusip }` }
      target="_blank"
    >
      { cellData }
    </Link>
  )
   : '-');
};

export default DealLink;
